const ID = 'tab';

export default ID;
